export const RPC_TERMS_ENDPOINTS = {
    GET_TERMS: "/get_terms_and_condition",
    GET_PRIVACY_POLICY: "/get_privacy_policy",
    GET_REGISTER_CATEGORIES: "/get_register_influencer_categories",
    GET_ACCOUNT_AGE_LIST: "/get_account_age_list",
    GET_COUNTRY_LIST: "/get_country_list",
};
